var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAttachFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    transform: "translate(-1259 -287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 24,
    height: 24,
    transform: "translate(1259 287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paperclip",
    d: "M18,8.889l-7.564,7.134a5.155,5.155,0,0,1-6.988,0,4.475,4.475,0,0,1,0-6.591L11.013,2.3a3.436,3.436,0,0,1,4.659,0,2.984,2.984,0,0,1,0,4.394L8.1,13.826a1.718,1.718,0,0,1-2.329,0,1.492,1.492,0,0,1,0-2.2l6.988-6.583",
    transform: "translate(1261.498 290.112)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAttachFileIcon);
export default __webpack_public_path__ + "static/media/report-attach-file-icon.b37afde6f573e3efbe4f52d8f78d0eb5.svg";
export { ForwardRef as ReactComponent };